import { CSSProperties } from "react";

import { EdgeProps, getBezierPath, Position } from "reactflow";

import { Observer } from "mobx-react-lite";
import { EdgeTypeIcon } from "../../../app/common/Icons";
import { useStore } from "../../../app/stores/store";
import "./CustomEdge.css";

const foreignObjectSize = 30;

interface Props extends EdgeProps {
  id: string;
  sourceX: number;
  sourceY: number;
  targetX: number;
  targetY: number;
  sourcePosition: Position;
  targetPosition: Position;
  label: string;
  style: CSSProperties;
}

export default function CustomEdge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  label,
  selected,
  source,
  target,
}: Props) {
  const { graphStore } = useStore();

  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY: targetY + 5,
    targetPosition,
  });

  const buttonOffset = getButtonOffset(sourceX, sourceY, targetX, targetY);

  return (
    <Observer>
      {() => {
        const isDisabledEdge =
          graphStore.selectedNode &&
          source !== graphStore.selectedNode.id &&
          target !== graphStore.selectedNode.id;

        return (
          <>
            <path
              id={id}
              className={"react-flow__edge-path stroke-width-2"}
              d={edgePath}
              style={isDisabledEdge ? { opacity: "0.2" } : {}}
            />
            <foreignObject
              width={foreignObjectSize}
              height={foreignObjectSize}
              x={labelX + buttonOffset.x - foreignObjectSize / 2}
              y={labelY + buttonOffset.y - foreignObjectSize / 2}
              requiredExtensions="http://www.w3.org/1999/xhtml"
              style={isDisabledEdge ? { opacity: "0.2" } : {}}
            >
              <div unselectable="on">
                <EdgeTypeIcon
                  width={foreignObjectSize}
                  height={foreignObjectSize}
                  color={selected ? "#404040" : "#9e9e9e"}
                  variant={label}
                />
              </div>

            </foreignObject>
          </>
        );
      }}
    </Observer>
  );
}

const getButtonOffset = (
  sourceX: number,
  sourceY: number,
  targetX: number,
  targetY: number
): { x: number; y: number } => {
  // fixed offset
  const offset = 30;

  // normal vector of the line which through "source" and "target" 2 points
  const normal = {
    x: targetY - sourceY,
    y: sourceX - targetX,
  };

  // normal vector length
  const normalLength = Math.sqrt(normal.x * normal.x + normal.y * normal.y);

  // button will floating on normal line
  // with offset 15 and bezier curve algorithm will ensure that button will nerver overlap the line
  return {
    x: (normal.x / normalLength) * offset,
    y: (normal.y / normalLength) * offset,
  };
};
